// hooks/usePushNotifications.js
import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import {
  requestNotificationPermission,
  saveNotificationPreference,
  getNotificationPreference
} from '../services/pushNotificationService';

/**
 * Hook to initialize and manage push notifications
 * Automatically requests permission and saves preferences
 */
export const usePushNotifications = () => {
  const { userData: user } = useAuth();

  useEffect(() => {
    if (!user || !user.uid) return;

    const initializeNotifications = async () => {
      try {
        // Check if browser supports notifications
        if (!('Notification' in window)) {
          console.warn('This browser does not support notifications');
          return;
        }

        // Get existing preference
        const prefResult = await getNotificationPreference(user.uid);
        
        // If user hasn't set a preference yet and permission isn't denied
        if (!prefResult.preference && Notification.permission !== 'denied') {
          // Auto-request permission on first login (optional - you can remove this)
          // const permission = await requestNotificationPermission();
          
          // Or just save current state without requesting
          await saveNotificationPreference(
            user.uid,
            user.role,
            Notification.permission === 'granted'
          );
        } else if (prefResult.preference) {
          // Update permission state if it changed outside the app
          if (prefResult.preference.permission !== Notification.permission) {
            await saveNotificationPreference(
              user.uid,
              user.role,
              Notification.permission === 'granted'
            );
          }
        }
      } catch (error) {
        console.error('Error initializing push notifications:', error);
      }
    };

    initializeNotifications();
  }, [user]);

  return null;
};

export default usePushNotifications;
